<template>
  <div>
    <!-- 售后订单详情（通用组件：售后列表页与主订单页共用） -->
    <el-dialog title="售后订单详情" :visible="visible" width="820px" append-to-body :close-on-click-modal="false"
      @close="handleClose">
      <div v-loading="detailLoading">
        <div class="section-title">售后订单信息</div>
        <el-row :gutter="16" class="detail-row">
          <el-col :span="12">
            <span class="detail-label">售后编号</span>
            <span class="detail-value">{{ detail.order.afterSaleNo || '-' }}</span>
          </el-col>
          <el-col :span="12">
            <span class="detail-label">售后状态</span>
            <span class="detail-value">
              <el-tag :type="statusTagType(detail.order.status)" size="mini">{{ statusLabel(detail.order.status)
              }}</el-tag>
            </span>
          </el-col>
          <el-col :span="12">
            <span class="detail-label">业务线</span>
            <span class="detail-value">{{ businessLabel(detail.order.type) }}</span>
          </el-col>
          <el-col :span="12">
            <span class="detail-label">售后来源</span>
            <span class="detail-value">{{ sourceLabel(detail.order.sourceType) }}</span>
          </el-col>
          <!-- <el-col :span="12">
            <span class="detail-label">是否过保</span>
            <span class="detail-value">{{ overinsuredLabel(detail.order.overinsuredFlag) }}</span>
          </el-col> -->
          <el-col :span="12">
            <span class="detail-label">创建时间</span>
            <span class="detail-value">{{ formatTime(detail.order.createTime) }}</span>
          </el-col>
          <el-col :span="12">
            <span class="detail-label">客户姓名</span>
            <span class="detail-value">{{ detail.order.customName || '-' }}</span>
          </el-col>
          <el-col :span="12">
            <span class="detail-label">客户电话</span>
            <span class="detail-value">{{ detail.order.customMobile || '-' }}</span>
          </el-col>
          <el-col :span="24">
            <span class="detail-label">客户地址</span>
            <span class="detail-value">{{ detail.order.customAddress || '-' }}</span>
          </el-col>
          <el-col :span="12">
            <span class="detail-label">工程师姓名</span>
            <span class="detail-value">{{ detail.order.engineerName || '-' }}</span>
          </el-col>
          <el-col :span="12">
            <span class="detail-label">工程师电话</span>
            <span class="detail-value">{{ detail.order.engineerMobile || '-' }}</span>
          </el-col>
          <el-col :span="24">
            <span class="detail-label">故障现象</span>
            <span class="detail-value">{{ detail.order.faultPhenomenon || '-' }}</span>
          </el-col>
          <el-col :span="24" v-if="detail.order.faultPhotos">
            <span class="detail-label">故障照片</span>
            <span class="detail-value">
              <viewer :images="splitImages(detail.order.faultPhotos)">
                <img v-for="src in splitImages(detail.order.faultPhotos)" :src="src" :key="src" class="detail-img">
              </viewer>
            </span>
          </el-col>
          <el-col :span="24" v-if="detail.order.remarks">
            <span class="detail-label">备注</span>
            <span class="detail-value">{{ detail.order.remarks }}</span>
          </el-col>
          <el-col :span="24" v-if="detail.order.status === 'CANCELLED'">
            <span class="detail-label">作废原因</span>
            <span class="detail-value">{{ detail.order.cancelReason || '-' }}</span>
          </el-col>
        </el-row>

        <div class="section-title">
          <span>关联主订单（报单）</span>
          <span v-if="detail.parentDeclaration">
            <el-button type="primary" size="mini" plain icon="el-icon-view" class="parent-view-btn"
              @click="handleViewParent">查看主订单详情</el-button>
            <el-button type="primary" size="mini" plain icon="el-icon-tickets" class="parent-view-btn"
              :loading="parentOrderLoading" @click="handleViewParentOrder">查看主订单工单</el-button>
          </span>
        </div>
        <div v-if="detail.parentDeclaration">
          <el-row :gutter="16" class="detail-row">
            <el-col :span="12">
              <span class="detail-label">报单编号</span>
              <span class="detail-value">{{ detail.parentDeclaration.number || '-' }}</span>
            </el-col>
            <el-col :span="12">
              <span class="detail-label">业务线</span>
              <span class="detail-value">{{ businessLabel(detail.parentDeclaration.type) }}</span>
            </el-col>
            <el-col :span="12">
              <span class="detail-label">客户姓名</span>
              <span class="detail-value">{{ detail.parentDeclaration.customName || '-' }}</span>
            </el-col>
            <el-col :span="12">
              <span class="detail-label">客户电话</span>
              <span class="detail-value">{{ detail.parentDeclaration.customMobile || '-' }}</span>
            </el-col>
            <el-col :span="24">
              <span class="detail-label">客户地址</span>
              <span class="detail-value">{{ detail.parentDeclaration.customAddress || '-' }}</span>
            </el-col>
            <el-col :span="12">
              <span class="detail-label">一户一码</span>
              <span class="detail-value">{{ detail.parentDeclaration.houseCodeId || '-' }}</span>
            </el-col>
            <el-col :span="12">
              <span class="detail-label">创建时间</span>
              <span class="detail-value">{{ formatTime(detail.parentDeclaration.createTime) }}</span>
            </el-col>
          </el-row>
        </div>
        <div v-else class="empty-tip">纯手动售后，无关联主订单</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 主订单详情：复用防水商户报单查看弹窗 -->
    <merchant-view :visible.sync="parentVisible" :id="parentId" />

    <!-- 主订单工单：复用防水阶段工单弹窗（与商户页“工单”按钮打开的是同一个组件），售后详情反查主订单属跨模块互查，只读隐藏操作按钮 -->
    <view-water-proof-stage :visibleStage.sync="parentStageVisible" :orderId="parentId"
      :status="parentRow.orderStatus || ''" :id="parentId" :infoDetail="parentRow" :readonly="true"
      @openViewOrder="handleOpenParentViewOrder" />
    <!-- 阶段弹窗内触发查看旧版服务工单（orderId 为主报单 deliveryOrderId，id 为主报单 id），只读隐藏操作按钮 -->
    <merchant-view-order :visibleOrder.sync="parentOrderVisible" :orderId="parentOrderId" :id="parentId" :readonly="true" />
  </div>
</template>

<script>
import {
  AFTER_SALE_STATUS_DIC,
  AFTER_SALE_SOURCE_DIC,
  BUSINESS_TYPE_DIC,
  OVERINSURED_DIC,
  statusTagType
} from '@/const/salesCloud/afterSaleOption';
import { getAfterSaleDetail } from '@/api/salesCloud/afterSale';
// 主报单工单 id（deliveryOrderId）仅 ListV2 聚合返回，按主报单 id 单条查询
import { findWaterProof } from '@/api/work/waterProof/merchants';
import MerchantView from '@/views/work/waterProof/merchants/view.vue';
import ViewWaterProofStage from '@/views/work/waterProof/merchants/components/viewWaterProofStage.vue';
import MerchantViewOrder from '@/views/work/waterProof/merchants/components/viewOrder.vue';

export default {
  name: 'AfterSaleDetailDialog',
  components: { MerchantView, ViewWaterProofStage, MerchantViewOrder },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 售后订单id
    afterSaleId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      detailLoading: false,
      detail: {
        order: {},
        parentDeclaration: null
      },
      // 主订单查看弹窗
      parentVisible: false,
      parentId: '',
      // 主订单工单弹窗
      parentStageVisible: false,
      parentOrderVisible: false,
      parentOrderId: '',
      parentOrderLoading: false,
      parentRow: {}
    };
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.loadDetail();
      }
    }
  },
  methods: {
    statusTagType,
    // 统一解包：网关 data 可能是对象或 JSON 字符串
    parseData(res) {
      if (!res) return {};
      const data = res.data;
      if (typeof data === 'string') {
        try {
          return JSON.parse(data);
        } catch (e) {
          return {};
        }
      }
      return data || {};
    },
    statusLabel(val) {
      const item = AFTER_SALE_STATUS_DIC.find(i => i.value === val);
      return item ? item.label : (val || '-');
    },
    sourceLabel(val) {
      const item = AFTER_SALE_SOURCE_DIC.find(i => i.value === val);
      return item ? item.label : (val || '-');
    },
    businessLabel(val) {
      const item = BUSINESS_TYPE_DIC.find(i => i.value === val);
      return item ? item.label : (val || '-');
    },
    overinsuredLabel(val) {
      const item = OVERINSURED_DIC.find(i => i.value === val);
      return item ? item.label : (val || '-');
    },
    formatTime(val) {
      if (!val) return '-';
      const t = Number(val);
      if (!t) return '-';
      const d = new Date(t);
      const p = n => (n < 10 ? '0' + n : '' + n);
      return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
    },
    splitImages(str) {
      if (!str) return [];
      return str.split(',').filter(i => i);
    },
    loadDetail() {
      if (!this.afterSaleId) return;
      this.detailLoading = true;
      this.detail = { order: {}, parentDeclaration: null };
      getAfterSaleDetail(this.afterSaleId).then(res => {
        if (res && res.code == '200') {
          const data = this.parseData(res);
          this.detail = {
            order: data.order || {},
            parentDeclaration: data.parentDeclaration || null
          };
        } else {
          this.$message({
            showClose: true,
            message: (res && res.message) || '查询失败',
            type: 'error'
          });
        }
        this.detailLoading = false;
      }).catch(() => {
        this.detailLoading = false;
      });
    },
    handleViewParent() {
      if (!this.detail.parentDeclaration || !this.detail.parentDeclaration.id) {
        this.$message.error('缺少主订单id');
        return;
      }
      this.parentId = this.detail.parentDeclaration.id;
      this.parentVisible = true;
    },
    // 查看主订单工单：ListV2 按主订单 id 查整行后，打开与商户页“工单”按钮一致的阶段工单弹窗
    handleViewParentOrder() {
      const parent = this.detail.parentDeclaration;
      if (!parent || !parent.id) {
        this.$message.error('缺少主订单id');
        return;
      }
      this.parentOrderLoading = true;
      findWaterProof({ id: parent.id, page: 1, size: 1 }).then(res => {
        this.parentOrderLoading = false;
        if (res && res.code == '200') {
          const data = this.parseData(res);
          const row = (data && data.rows && data.rows[0]) || null;
          // 严格校验返回行就是当前主订单，防止 id 过滤未生效时错拿他单数据
          if (!row || String(row.id) !== String(parent.id)) {
            this.$message.warning('未查询到主订单信息');
            return;
          }
          this.parentRow = row;
          this.parentId = row.id;
          this.parentOrderId = row.deliveryOrderId || '';
          this.parentStageVisible = true;
        } else {
          this.$message({
            showClose: true,
            message: (res && res.message) || '查询主订单信息失败',
            type: 'error'
          });
        }
      }).catch(() => {
        this.parentOrderLoading = false;
      });
    },
    // 阶段工单弹窗内点“查看工单”时打开旧版服务工单（依赖主报单 deliveryOrderId）
    handleOpenParentViewOrder() {
      if (!this.parentOrderId) {
        this.$message.warning('主订单暂无服务工单');
        return;
      }
      this.parentOrderVisible = true;
    },
    handleClose() {
      this.$emit('update:visible', false);
    }
  }
};
</script>

<style lang="scss" scoped>
.section-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
  font-size: 15px;
  margin: 20px 0 16px;
  padding: 0 0 10px 10px;
  border-left: 3px solid #409eff;
  border-bottom: 1px solid #ebeef5;
  color: #303133;
}

.section-title:first-child {
  margin-top: 4px;
}

.parent-view-btn {
  margin-left: 12px;
}

.detail-row {
  margin-bottom: 0;
  padding: 4px 4px;
  border-bottom: 1px dashed #ebeef5;

  .el-col {
    line-height: 32px;
    color: #303133;
    padding: 8px 8px;
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
  }
}

.detail-row:last-child {
  border-bottom: 0;
}

.detail-label {
  color: #606266;
  font-size: 13px;
  min-width: 84px;
  margin-right: 6px;
}

.detail-value {
  color: #303133;
  font-size: 14px;
  flex: 1;
  min-width: 0;
}

.detail-img {
  width: 84px;
  height: 84px;
  object-fit: cover;
  margin: 4px 8px 4px 0;
  border-radius: 6px;
  border: 1px solid #ebeef5;
  cursor: pointer;
  transition: transform .2s ease, box-shadow .2s ease;
}

.detail-img:hover {
  transform: scale(1.04);
  box-shadow: 0 2px 8px rgba(0, 0, 0, .12);
}

.empty-tip {
  color: #909399;
  padding: 8px 0;
}

.dialog-footer {
  text-align: right;
}
</style>
